/**
 * 进程管理
 */
const ProcessRouter = {
  path: '/project',
  component: () => import('@/views/layout'),
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [
    {
      path: 'peocess/add',
      name: 'add_process',
      component: () => import('@/views/process_pages/components/change_process'),
      hidden: true,
      meta: {
        title: '添加进程'
      }
    },
    {
      path: 'peocess/table/edit/:id',
      name: 'edit_process',
      component: () => import('@/views/process_pages/components/change_process'),
      hidden: true,
      meta: {
        title: '编辑进程'
      }
    },
    {
      path: 'peocess/table/desc/:id',
      name: 'process_details',
      component: () => import('@/views/process_pages/components/process_details'),
      hidden: true,
      meta: {
        title: '进程详情'
      }
    }

  ]
}

export default ProcessRouter
